export default "__VITE_ASSET__BoKKg0NP__"